import { TranslatePipe } from "@ngx-translate/core";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ComponentAdapterCounterElectric } from "src/components/shared-components/class/adapters/component-adapter-counter-electric";
import { GenericCounterGraphData } from "src/components/shared-components/class/generic-counter-graph-data";
import { SmartPaletteCounter } from "src/components/shared-components/class/smart-palette";
import { WidgetCounterParent } from "src/components/shared-components/class/widget-counter-parent";
import { ElectricCounterMeasurementType } from "src/components/shared-components/enum/enumCounterMeasurementType";
import { AddressDetails } from "src/components/shared-components/class/smart-components/smart-component-property";
import { ChartSerieKind } from "src/components/shared-components/enum/enumChart";
import { SkillNameList } from "src/components/shared-components/enum/enumSkillNameList";
import { SmartComponentSummaryData } from "src/components/shared-components/class/smart-components/smart-component-property-details";
import { ChartPieData } from "src/components/shared-components/interfaces/chart-pie-data";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { WidgetCounterSkillExpandableComponent } from "../../widget-counter-skill-expandable/widget-counter-skill-expandable.component";
import { WidgetCounterBandComponent } from "../../widget-counter-band/widget-counter-band.component";
import { WidgetCounterBandTripleComponent } from "../../widget-counter-band-triple/widget-counter-band-triple.component";

@Component({
    selector: "app-counter-electric",
    templateUrl: "./counter-electric.component.html",
    styleUrls: ["./counter-electric.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WidgetCounterSkillExpandableComponent, WidgetCounterBandComponent, WidgetCounterBandTripleComponent, TranslatePipe]
})

/**
 * Electric Counter entry componet
 */
export class CounterElectricComponent extends WidgetCounterParent<ComponentAdapterCounterElectric> {
  public showBandEnergyAbsorbed: boolean = false;
  public showBandEnergyProduced: boolean = false;
  public showBandActivePower: boolean = false;
  public showBandActivePowerMax24h: boolean = false;
  public showBandActivePowerFedMax24h: boolean = false;
  public showBandActivePowerFed: boolean = false;
  public showBandExchangePower: boolean = false;
  public showBandActiveEnergyImportedPreviousDay: boolean = false;
  public umEnergyAbsorbed: string = "";
  public umEnergyProduced: string = "";
  public umActivePower: string = "";
  public umActivePowerMax24h: string = "";
  public umActivePowerFedMax24h: string = "";
  public umActivePowerFed: string = "";
  public umExchangePower: string = "";
  public umActiveEnergyImportedPreviousDay: string = "";
  public chartBarEnergyAbsorbed: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartBarEnergyProduced: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartBarExchangePower: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartLineActivePower: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartLineActivePowerMax24h: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartLineActivePowerFedMax24h: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartLineActivePowerFed: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartPieActiveEnergyImportedPreviousDay: ChartPieData[] = [];
  public chartSerieKind = ChartSerieKind;
  public chartBarEnergyAbsorbedCSV: string = "";
  public chartBarEnergyProducedCSV: string = "";
  public chartBarExchangePowerCSV: string = "";
  public chartLineActivePowerCSV: string = "";
  public chartLineActivePowerMax24hCSV: string = "";
  public chartLineActivePowerFedMax24hCSV: string = "";
  public chartLineActivePowerFedCSV: string = "";

  public previousyear: string = "";
  public currentyear: string = "";
  public absorbedEnergyPreviousMonth: string = "";
  public absorbedEnergyCurrentMonth: string = "";
  public absorbedEnergyPreviousYear: string = "";
  public absorbedEnergyCurrentYear: string = "";
  public producedEnergyPreviousMonth: string = "";
  public producedEnergyCurrentMonth: string = "";
  public producedEnergyPreviousYear: string = "";
  public producedEnergyCurrentYear: string = "";
  public powerExchangePreviousMonth: string = "";
  public powerExchangeCurrentMonth: string = "";
  public powerExchangePreviousYear: string = "";
  public powerExchangeCurrentYear: string = "";
  public activePower: string = "";
  public errorChartAbsorbedEnergy: boolean = false;
  public errorChartProducedEnergy: boolean = false;
  public errorChartActivePower: boolean = false;
  public errorChartActivePowerMax24h: boolean = false;
  public errorChartActivePowerFedMax24h: boolean = false;
  public errorChartExchangePower: boolean = false;
  public errorChartActivePowerFed: boolean = false;
  public errorChartActiveEnergyImportedPreviousDay: boolean = false;
  public skillType = SkillNameList;
  @Input() public headerSummary: SmartComponentSummaryData = null;

  protected async onComponentLoad(): Promise<void> {
    //We need to call method for get chart data
    this.setMeasurements();

    try {
      await this._loaderService.presentLoaderWaiting();

      if (this.componentAdapter.EnergyAbsorbed) {
        this.umEnergyAbsorbed =
          this.componentAdapter.EnergyAbsorbed.measureUnit;
        this.showBandEnergyAbsorbed = true;
        try {
          if (this.componentAdapter.Summary) {
            this.chartBarEnergyAbsorbed =
              await this.getSummaryYearlyForMonthConsumption(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_ENERGY_ABSORBED
              );
            this.chartBarEnergyAbsorbed = this.roundChartData(
              this.chartBarEnergyAbsorbed,
              true
            );
            if (this.chartBarEnergyAbsorbed.data.length === 0) {
              this.showBandEnergyAbsorbed = false;
            }
            this.chartBarEnergyAbsorbedCSV =
              await this.getSummaryYearlyForMonthConsumptionCSV(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_ENERGY_ABSORBED
              );
          } else {
            this.chartBarEnergyAbsorbed =
              await this.getYearlyForMonthConsumption(
                this.componentAdapter.EnergyAbsorbed.address,
                this.componentAdapter.EnergyAbsorbed.instanceGUID
              );
            this.chartBarEnergyAbsorbed = this.roundChartData(
              this.chartBarEnergyAbsorbed,
              true
            );
            this.chartBarEnergyAbsorbedCSV =
              await this.getYearlyForMonthConsumptionCSV(
                this.componentAdapter.EnergyAbsorbed.address,
                this.componentAdapter.EnergyAbsorbed.instanceGUID
              );
          }
        } catch {
          this.errorChartAbsorbedEnergy = true;
        }
      }

      if (this.componentAdapter.EnergyProduced) {
        this.umEnergyProduced =
          this.componentAdapter.EnergyProduced.measureUnit;
        this.showBandEnergyProduced = true;
        try {
          if (this.componentAdapter.Summary) {
            this.chartBarEnergyProduced =
              await this.getSummaryYearlyForMonthConsumption(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_ENERGY_PRODUCED
              );
            this.chartBarEnergyProduced = this.roundChartData(
              this.chartBarEnergyProduced,
              true
            );
            if (this.chartBarEnergyProduced.data.length === 0) {
              this.showBandEnergyProduced = false;
            }
            this.chartBarEnergyProducedCSV =
              await this.getSummaryYearlyForMonthConsumptionCSV(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_ENERGY_PRODUCED
              );
          } else {
            this.chartBarEnergyProduced =
              await this.getYearlyForMonthConsumption(
                this.componentAdapter.EnergyProduced.address,
                this.componentAdapter.EnergyProduced.instanceGUID
              );

            this.chartBarEnergyProduced = this.roundChartData(
              this.chartBarEnergyProduced,
              true
            );
            this.chartBarEnergyProducedCSV =
              await this.getYearlyForMonthConsumptionCSV(
                this.componentAdapter.EnergyProduced.address,
                this.componentAdapter.EnergyProduced.instanceGUID
              );
          }
        } catch {
          this.errorChartProducedEnergy = true;
        }
      }

      if (this.componentAdapter.ExchangePower) {
        this.umExchangePower = this.componentAdapter.ExchangePower.measureUnit;

        this.showBandExchangePower = true;
        try {
          if (this.componentAdapter.Summary) {
            this.chartBarExchangePower =
              await this.getSummaryYearlyForMonthConsumption(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_POWER_EXCHANGE
              );
            this.chartBarExchangePower = this.roundChartData(
              this.chartBarEnergyProduced,
              true
            );
            if (this.chartBarExchangePower.data.length === 0) {
              this.showBandExchangePower = false;
            }
            this.chartBarExchangePowerCSV =
              await this.getSummaryYearlyForMonthConsumptionCSV(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_ELECTRIC_POWER_EXCHANGE
              );
          } else {
            this.chartBarExchangePower =
              await this.getYearlyForMonthConsumption(
                this.componentAdapter.ExchangePower.address,
                this.componentAdapter.ExchangePower.instanceGUID
              );

            this.chartBarExchangePower = this.roundChartData(
              this.chartBarExchangePower,
              true
            );
            this.chartBarExchangePowerCSV =
              await this.getYearlyForMonthConsumptionCSV(
                this.componentAdapter.ExchangePower.address,
                this.componentAdapter.ExchangePower.instanceGUID
              );
          }
        } catch {
          this.errorChartExchangePower = true;
        }
      }

      await this.updateLineChart();
      await this.updatePieChart();
    } finally {
      await this._loaderService.dismissLoaderWaiting();
    }
  }
  protected onComponentDestroy(): void { }

  //STUB
  protected onSmartComponentSuccessLoaded(): void {
    //[...]
  }

  /**
   * Update data on line chart when swipe
   * @param date
   */
  public async handleSwipeDataOnLineChart(date: Date) {
    this.setPeriodByDate(date);
    await this.updateLineChart();
  }

  /**
   * Update data of pie chart when swiping
   * @param date
   */
  public async handleSwipeDataOnPieChart(date: Date) {
    this.setPeriodByDate(date);
    await this.updatePieChart();
  }

  /**
   * This method update the pie chart data with the new date.
   */
  public async updatePieChart(): Promise<void> {
    if (this.isThereEnergyImportedPreviousDay()) {
      this.umActiveEnergyImportedPreviousDay = this.componentAdapter.EnergyImportedPreviousDayF1?.measureUnit || this.componentAdapter.EnergyImportedPreviousDayF2?.measureUnit ||
        this.componentAdapter.EnergyImportedPreviousDayF3?.measureUnit || this.componentAdapter.EnergyImportedPreviousDayF4?.measureUnit ||
        this.componentAdapter.EnergyImportedPreviousDayF5?.measureUnit || this.componentAdapter.EnergyImportedPreviousDayF6?.measureUnit;

      this.showBandActiveEnergyImportedPreviousDay = true;

      const consumptionData: ChartPieData[] = [];

      try {
        await this._loaderService.presentLoaderWaiting();
        if (this.componentAdapter.EnergyImportedPreviousDayF1) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF1, "F1"));
        }

        if (this.componentAdapter.EnergyImportedPreviousDayF2) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF2, "F2"));
        }

        if (this.componentAdapter.EnergyImportedPreviousDayF3) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF3, "F3"));
        }

        if (this.componentAdapter.EnergyImportedPreviousDayF4) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF4, "F4"));
        }

        if (this.componentAdapter.EnergyImportedPreviousDayF5) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF5, "F5"));
        }

        if (this.componentAdapter.EnergyImportedPreviousDayF6) {
          consumptionData.push(await this.getConsumptionForEnergyImportedPreviousDay(this.componentAdapter.EnergyImportedPreviousDayF6, "F6"));
        }

        this.chartPieActiveEnergyImportedPreviousDay = consumptionData;
        await this._loaderService.dismissLoaderWaiting();
      } catch {
        await this._loaderService.dismissLoaderWaiting();
        this.errorChartActiveEnergyImportedPreviousDay = true;
      }
    }
  }

  /**
   * This method update the line chart data with the new date.
   */
  public async updateLineChart(): Promise<void> {
    if (this.componentAdapter.ActivePower) {
      this.umActivePower = this.componentAdapter.ActivePower.measureUnit;
      this.showBandActivePower = true;
      try {
        this.chartLineActivePower = await this.getPeaksData(
          this.componentAdapter.ActivePower.address,
          this.componentAdapter.ActivePower.instanceGUID
        );
        this.chartLineActivePower = this.roundChartData(
          this.chartLineActivePower,
          false
        );
        this.chartLineActivePowerCSV = await this.getPeaksDataCSV(
          this.componentAdapter.ActivePower.address,
          this.componentAdapter.ActivePower.instanceGUID
        );
      } catch {
        this.errorChartActivePower = true;
      }
    }

    if (this.componentAdapter.ActivePowerMax24h) {
      this.umActivePowerMax24h = this.componentAdapter.ActivePowerMax24h.measureUnit;
      this.showBandActivePowerMax24h = true;
      try {
        this.chartLineActivePowerMax24h = await this.getPeaksData(
          this.componentAdapter.ActivePowerMax24h.address,
          this.componentAdapter.ActivePowerMax24h.instanceGUID
        );
        this.chartLineActivePowerMax24h = this.roundChartData(
          this.chartLineActivePowerMax24h,
          false
        );
        this.chartLineActivePowerMax24hCSV = await this.getPeaksDataCSV(
          this.componentAdapter.ActivePowerMax24h.address,
          this.componentAdapter.ActivePowerMax24h.instanceGUID
        );
      } catch {
        this.errorChartActivePowerMax24h = true;
      }
    }

    if (this.componentAdapter.ActivePowerFedMax24h) {
      this.umActivePowerFedMax24h = this.componentAdapter.ActivePowerFedMax24h.measureUnit;
      this.showBandActivePowerFedMax24h = true;
      try {
        this.chartLineActivePowerFedMax24h = await this.getPeaksData(
          this.componentAdapter.ActivePowerFedMax24h.address,
          this.componentAdapter.ActivePowerFedMax24h.instanceGUID
        );
        this.chartLineActivePowerFedMax24h = this.roundChartData(
          this.chartLineActivePowerFedMax24h,
          false
        );
        this.chartLineActivePowerFedMax24hCSV = await this.getPeaksDataCSV(
          this.componentAdapter.ActivePowerFedMax24h.address,
          this.componentAdapter.ActivePowerFedMax24h.instanceGUID
        );
      } catch {
        this.errorChartActivePowerFedMax24h = true;
      }
    }

    if (this.componentAdapter.ActivePowerFed) {
      this.umActivePowerFed = this.componentAdapter.ActivePowerFed.measureUnit;
      this.showBandActivePowerFed = true;
      try {
        this.chartLineActivePowerFed = await this.getPeaksData(
          this.componentAdapter.ActivePowerFed.address,
          this.componentAdapter.ActivePowerFed.instanceGUID
        );
        this.chartLineActivePowerFed = this.roundChartData(
          this.chartLineActivePowerFed,
          false
        );
        this.chartLineActivePowerFedCSV = await this.getPeaksDataCSV(
          this.componentAdapter.ActivePowerFed.address,
          this.componentAdapter.ActivePowerFed.instanceGUID
        );
      } catch {
        this.errorChartActivePowerFed = true;
      }
    }
  }

  /**
   * Check if the widget has energy imported previous day
   * @returns true if component has at least one of the six skill of energy imported previous day
   */
  private isThereEnergyImportedPreviousDay(): boolean {
    return Boolean(this.componentAdapter.EnergyImportedPreviousDayF1 || this.componentAdapter.EnergyImportedPreviousDayF2 || this.componentAdapter.EnergyImportedPreviousDayF3 ||
      this.componentAdapter.EnergyImportedPreviousDayF4 || this.componentAdapter.EnergyImportedPreviousDayF5 || this.componentAdapter.EnergyImportedPreviousDayF6)
  }

  /**
   * Handle the API call for consumption of energy imported previous day in order to build chart
   * @param address of energy imported previous day
   */
  private async getConsumptionForEnergyImportedPreviousDay(address: AddressDetails, timeSlot: string): Promise<ChartPieData> {
    const monthlyConsumptionForAYear = await this.getYearlyForMonthConsumption(
      address.address,
      address.instanceGUID
    );
    const currentYear = new Date().getFullYear();

    //Return the data only of the current month
    return monthlyConsumptionForAYear.data.filter(item => item.month === this.startDate.getMonth() + 1).map(item => {
      return {
        name: timeSlot,
        value: parseFloat(StaticClass.formatDecimalValue(this.startDate.getFullYear() === currentYear ? item.currentYearValue : item.lastYearValue, this.defaultDecimalDigits))
      }
    })[0];
  }

  /**
   * This method set the displayed data defined throught the current "Measurements" associated to the
   * SmartComponent associated to this Widget.
   */
  private setMeasurements(): void {
    this.previousyear =
      this._translateService.instant("dictionary.year") + " " + this.componentAdapter.PreviousYear;
    this.currentyear = this._translateService.instant("dictionary.year") + " " + this.componentAdapter.CurrentYear;

    this.absorbedEnergyPreviousMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_ABSORBED_PREVIOUS_MONTH
        ]
      ) || "---";
    this.absorbedEnergyCurrentMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_ABSORBED_LAST_MONTH
        ]
      ) || "---";
    this.absorbedEnergyPreviousYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_ABSORBED_PREVIOUS_YEAR
        ]
      ) || "---";
    this.absorbedEnergyCurrentYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_ABSORBED_LAST_YEAR
        ]
      ) || "---";

    this.producedEnergyPreviousMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_PRODUCED_PREVIOUS_MONTH
        ]
      ) || "---";
    this.producedEnergyCurrentMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_PRODUCED_LAST_MONTH
        ]
      ) || "---";
    this.producedEnergyPreviousYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_PRODUCED_PREVIOUS_YEAR
        ]
      ) || "---";
    this.producedEnergyCurrentYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ENERGY_PRODUCED_LAST_YEAR
        ]
      ) || "---";

    this.powerExchangePreviousMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_POWER_EXCHANGE_PREVIOUS_MONTH
        ]
      ) || "---";
    this.powerExchangeCurrentMonth =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_POWER_EXCHANGE_LAST_MONTH
        ]
      ) || "---";
    this.powerExchangePreviousYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_POWER_EXCHANGE_PREVIOUS_YEAR
        ]
      ) || "---";
    this.powerExchangeCurrentYear =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_POWER_EXCHANGE_LAST_YEAR
        ]
      ) || "---";

    this.activePower =
      this.componentAdapter.MeasurementMap.get(
        ElectricCounterMeasurementType[
        ElectricCounterMeasurementType.ELECTRIC_ACTIVE_POWER
        ]
      ) || "---";
  }
}
